import { useContext } from 'react'

import { ChatThemeContext } from './ChatThemeContext'

/**
 * @brief This hook can be used to retrieve the active color theme.
 * @returns {object} theme: light | dark
 * @usage const { theme } = useTheme()
 */
export const useChatTheme = () => {
  const { theme } = useContext(ChatThemeContext)

  return {
    theme,
  }
}
